import request from '@/utils/request';
// 拟立项

//拟立项列表
export const getprojectDeclareQuasiList = params => {
    return request({
        url: '/api/eduProjectDeclare/projectDeclareQuasiList',
        method: 'post',
        data:params
    });
};
//立项或者不立项操作
export const auditProject = params => {
    return request({
        url: '/api/eduProjectDeclare/auditProject',
        method: 'post',
        data:params
    });
};
//立项列表
export const getProjectList = params => {
    return request({
        url: '/api/eduProjectDeclare/projectList',
        method: 'post',
        data:params
    });
};
//导出立项word
export const getProjectWord = () => {
    return request({
        url: '/api/eduProjectDeclare/getProjectListWord',
        method: 'get',
        responseType:'blob'
    });
};